import * as actionTypes from '../../constants/actionTypes';
import { DESCENDING_ORDER } from '../../constants/users';

const initialState = {
  isLoading: false,
  error: undefined,
  search: '',
  sortBy: { column: 'id', order: DESCENDING_ORDER.toLowerCase() },
  pagination: {
    page: 1,
    itemsAmount: 10,
  },
  filters: {},
};

const sessionDevices = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_SESSION_DEVICES_SORT_BY:
      return { ...state, sortBy: action.payload.sortBy };

    case actionTypes.CLEAR_SESSION_DEVICES_FILTERS:
      return initialState;

    case actionTypes.SET_SESSION_DEVICES_SEARCH:
      return { ...state, search: action.payload.search, pagination: initialState.pagination };

    case actionTypes.SET_SESSION_DEVICES_PAGINATION:
      return { ...state, pagination: action.payload.pagination };
    case actionTypes.SET_SESSION_DEVICES_FILTERS:
      return {
        ...state,
        filters: { ...state.filters, ...action.payload.filters },
        pagination: initialState.pagination,
      };

    default:
      return state;
  }
};

export default sessionDevices;
